import { useEffect, useRef, memo } from 'react';
import { isMetaPage } from '../util/util';
import WikiTooltip from './WikiTooltip';

import "../../css/all4.css";

const WikiArticle = memo(({ wikiContent, loading, settings, target, onNavigate }) => {
  const wikiRef = useRef();
  const loadingRef = useRef(loading);
  const settingsRef = useRef(settings);
  const onNavigateRef = useRef(onNavigate);

  loadingRef.current = loading;
  settingsRef.current = settings;
  onNavigateRef.current = onNavigate;

  // Native capture-phase click handler — completely outside React's event system
  useEffect(() => {
    const container = wikiRef.current;
    if (!container) return;

    const handleClick = (e) => {
      const anchor = e.target.closest('a');
      if (!anchor) return;
      e.preventDefault();

      if (loadingRef.current) return;

      const path = decodeURIComponent(anchor.getAttribute('href'));
      if (!settingsRef.current?.metaPages && isMetaPage(path)) return;

      const re = /^(?:.*\/)?wiki\/(.*)$/;
      const match = path.match(re);
      if (match?.length > 1) {
        onNavigateRef.current(match[1]);
      }
    };

    container.addEventListener('click', handleClick, true);
    return () => container.removeEventListener('click', handleClick, true);
  }, []);

  let wikiClassName = 'wiki';
  if (!settings?.infoboxes) wikiClassName += ' no-infoboxes';
  if (!settings?.thumbnails) wikiClassName += ' no-thumbs';
  if (!settings?.seeAlso) wikiClassName += ' no-navboxes';
  if (!settings?.navboxes) wikiClassName += ' no-navboxes';

  return (
    <>
      <div
        ref={wikiRef}
        className={`${wikiClassName} vector-body ve-init-mw-desktopArticleTarget-targetContainer${loading ? ' loading' : ''}`}
        dangerouslySetInnerHTML={{ __html: wikiContent }}
      />
      <WikiTooltip containerRef={wikiRef} target={target} settings={settings} />
    </>
  );
});

export default WikiArticle;
